import { useEffect } from 'react';

// Erzeugt Article- + FAQPage-JSON-LD aus dem geladenen Grounding-HTML (FAQ = sichtbarer Inhalt)
export const useGroundingSchemas = (htmlContent, { headline, description, path }) => {
  useEffect(() => {
    if (!htmlContent) return;
    const scripts = [];
    const add = (data) => {
      const s = document.createElement('script');
      s.type = 'application/ld+json';
      s.text = JSON.stringify(data);
      document.head.appendChild(s);
      scripts.push(s);
    };

    add({
      '@context': 'https://schema.org',
      '@type': 'Article',
      headline,
      description,
      inLanguage: 'de-CH',
      author: { '@type': 'Organization', name: 'marKIpilot', url: 'https://markipilot.com' },
      publisher: {
        '@type': 'Organization',
        name: 'MYSYMP AG',
        logo: { '@type': 'ImageObject', url: 'https://markipilot.com/icons/icon.svg' },
      },
      mainEntityOfPage: { '@type': 'WebPage', '@id': `https://markipilot.com${path}` },
    });

    const doc = new DOMParser().parseFromString(htmlContent, 'text/html');
    const questions = Array.from(doc.querySelectorAll('.faq-item')).map((item) => ({
      q: item.querySelector('.faq-question')?.textContent?.trim(),
      a: item.querySelector('.faq-answer')?.textContent?.trim(),
    })).filter((f) => f.q && f.a);

    if (questions.length > 0) {
      add({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        inLanguage: 'de-CH',
        mainEntity: questions.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: { '@type': 'Answer', text: f.a },
        })),
      });
    }

    return () => scripts.forEach((s) => s.remove());
  }, [htmlContent, headline, description, path]);
};

export default useGroundingSchemas;
